type ChangeDetailsElementProps = {
  title: string;
  oldValue: string;
  newValue: string;
};

export const ChangeDetailsElement = ({
  title,
  oldValue,
  newValue,
}: ChangeDetailsElementProps) => {
  return (
    <div className="flex flex-col gap-sm">
      <div className="text-medium text-sm text-secondary">{title}</div>
      <div className="text-sm text-primary">
        <span>
          {oldValue ? oldValue : <span className="text-tertiary">None</span>} →
        </span>{" "}
        <span className="font-semibold">{newValue}</span>
      </div>
    </div>
  );
};
